import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import styled, { injectGlobal, keyframes } from 'styled-components'

import logo from './logo.svg'

injectGlobal`
  body {
    margin: 0;
  }

  html {
    font-family: 'Inknut Antiqua', serif;
    font-size: 18px;
    background: #3a00ff;
    color: #fff;
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: #fff;
    margin: 0;
  }

  a:hover {
    color: #42ffae;
  }
`

const fadeIn = keyframes`
  from { opacity: 0;  }
  to   { opacity: 1; }
`

const H1 = styled.h1`
  margin: 0 0 1em 0;
  animation: ${fadeIn} 1s;
  animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
`

const Logo = styled.img`
  display: block;
  width: 185px;
`

const Padding = styled.div`
  padding: 3em;
`
const Content = styled.div`
  animation: ${fadeIn} 2s;
  animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
`

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content:
            'We help social media publishers maximise creative content, reaching the right audiences to engage key demographics. Siml makes social simple.',
        },
        {
          name: 'keywords',
          content: 'social, media, marketing, Cardiff, Wales',
        },
      ]}
    />

    <Padding>
      <H1>
        <a href="/">
          <Logo src={logo} alt="Siml" />
        </a>
      </H1>
      <Content>{children()}</Content>
    </Padding>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js